import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Tween, ScrollTrigger } from "react-gsap";
import ImageHandler from "../../utils/ImageHandler";
import SmartText from "../../utils/TextHandler";
import SmartColour from "../../utils/ColourHandler";

const SectionBody = (props) => {
  const { doc } = props;
  const colour = SmartColour(doc.colour);

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const detectMobile = () => {
      setIsMobile(window.innerWidth <= 768 ? true : false);
    };

    // Initial Mobile Check
    detectMobile();

    // Recheck if mobile on window resize
    if (typeof window !== "undefined") {
      window.addEventListener("resize", detectMobile);
    }

    return () => {
      // Remove event listener so we arent checking forever
      if (typeof window !== "undefined") {
        window.removeEventListener("resize", detectMobile);
      }
    };
  }, []);

  return (
    <section
      id={doc.id && doc.id}
      className={`brand-section py-5 py-lg-10 d-flex flex-column justify-content-center align-items-center brand-background-${colour.background} brand-text-${colour.text} brand-background-cover`}
      style={
        isMobile === true
          ? doc.mobile_background && doc.mobile_background.filename
            ? {
                backgroundImage: `url(${ImageHandler(
                  doc.mobile_background.filename,
                  "558x992"
                )})`,
                backgroundPosition: "top center",
                backgroundSize: "cover",
              }
            : {
                minHeight: "auto",
              }
          : doc.background && doc.background.filename
          ? {
              backgroundImage: `url(${ImageHandler(
                doc.background.filename,
                "1920x1080"
              )})`,
            }
          : {}
      }
    >
      <ScrollTrigger start="0 bottom" end="0 top" scrub>
        <div className="container">
          {isMobile === true && doc?.mobile_background?.filename && (
            <div className="div ratio ratio-16x9" />
          )}
          <div
            className={`row gy-4 justify-content-${
              doc.align ? doc.align : "center"
            }`}
          >
            <div
              className={`col-12 ${
                doc.width === "75%" ? "col-lg-8" : "col-lg-12"
              }`}
            >
              {(doc.title || doc.body) && (
                <Tween from={{ y: "100px" }} to={{ y: "0" }}>
                  <div
                    className={
                      doc.box === "dark"
                        ? "brand-background-dark p-4 p-md-5"
                        : doc.box === "light"
                        ? "brand-background-light p-4 p-md-5"
                        : null
                    }
                  >
                    {doc.title && (
                      <h2
                        className={`brand-font mb-3 brand-text-dirty brand-text-${colour.headline} brand-font-responsive`}
                      >
                        {doc.title}
                      </h2>
                    )}
                    {doc.body && (
                      <div>
                        <SmartText>{doc.body}</SmartText>
                      </div>
                    )}
                  </div>
                </Tween>
              )}
            </div>
          </div>
        </div>
      </ScrollTrigger>
    </section>
  );
};

export default SectionBody;

SectionBody.propTypes = {
  doc: PropTypes.object,
};

SectionBody.defaultProps = {
  doc: null,
};
